import React from 'react';
import './Footer.css'; // External CSS for styling
import unl from './assets/Nebraska_N_RGB.png';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <img src={unl} alt="Footer Logo" />
      </div>
      <div className="footer-content">
        <p>© 2024 Game Title. All rights reserved.</p>

        {/* Social Media Links */}
        <div className="social-media">
          <a href="https://www.unl.edu/" target="_blank" rel="noreferrer">
            University of Nebraska-Lincoln
          </a>
        </div>

        {/* Legal Links */}
        {/* <div className="footer-links">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
